import { Vector3 } from "three";

export interface CameraState {
  target: Vector3;
  zoom: number;
  isTracking: boolean;
  mapMode: boolean;
  history: Vector3[];
}

export const initialState: CameraState = {
  target: new Vector3(0, 0, 0),
  zoom: 0,
  isTracking: false,
  mapMode: true,
  history: []
};
